module.exports = __webpack_public_path__ + "static/media/icons8-spring-boot.31d9ace3.svg";